import React, { useEffect, useState } from 'react';
import { CarSearch, type ICarSearchProps } from './containers';
import ContextStore from './contexts';
import { useIsMobile } from './hooks';
import { init } from './services/core';

const AppWrapper = ({ ...props }: ICarSearchProps) => {
  const [hasInitializedCore, setHasInitializedCore] = useState<boolean>(false);

  useEffect(() => {
    async function initializeCore() {
      const result = await init();
      setHasInitializedCore(result.success);

      if (!result.success) {
        console.error('Error initializing core');
      }
    }

    initializeCore();
  }, []);

  if (!hasInitializedCore) {
    return <div />;
  }

  return (
    <ContextStore>
      <App {...props} />
    </ContextStore>
  );
};

const App = ({ ...props }: ICarSearchProps) => {
  useIsMobile();

  return <CarSearch {...props} />;
};

export default AppWrapper;

// Since this file is marked as the main file, we must export these from here
// This does the following: import { your-containers } from '@smiles/smiles-react-car-search-ut';
export * from './types';
export { AppWrapper as CarSearch };
